export const JSON_WATCHLIST = `{
  "name": "Watchlist",
  "types": [
    {
      "id": 100,
      "supertype": "uievent",
      "name": "Product Clicked",
      "attributes": [
        {
          "name": "Product",
          "type": "Product"
        }
      ]
    },
    {
      "id": 101,
      "supertype": "uievent",
      "name": "Remove-Product Clicked",
      "attributes": [
        {
          "name": "Product",
          "type": "Product"
        }
      ]
    },
    {
      "id": 102,
      "supertype": "uievent",
      "name": "Clear Unavailable Items"
    },
    {
      "id": 103,
      "supertype": "uievent",
      "name": "Login Clicked"
    },
    {
      "id": 104,
      "supertype": "uievent",
      "name": "Get-Inspired Clicked"
    },
    {
      "id": 105,
      "supertype": "uievent",
      "name": "Retry Clicked"
    },
    {
      "id": 106,
      "supertype": "uievent",
      "name": "Refresh Requested"
    },
    {
      "id": 107,
      "supertype": "uievent",
      "name": "Last Seen Products Scroller scrolled",
      "attributes": [
        {
          "name": "Tracking Info",
          "type": "String"
        }
      ]
    },
    {
      "id": 108,
      "supertype": "uievent",
      "name": "Last Seen Product clicked",
      "attributes": [
        {
          "name": "Item Position",
          "type": "Number"
        },
        {
          "name": "Tracking Info",
          "type": "String"
        },
        {
          "name": "Item Tracking Info",
          "type": "(String)"
        }
      ]
    },
    {
      "id": 109,
      "supertype": "uievent",
      "name": "Last Seen Products Scroller header clicked",
      "attributes": [
        {
          "name": "Tracking Info",
          "type": "String"
        }
      ]
    },
    {
      "id": 110,
      "supertype": "uievent",
      "name": "Last Seen Products more clicked",
      "attributes": [
        {
          "name": "Item Position",
          "type": "Number"
        },
        {
          "name": "Tracking Info",
          "type": "String"
        }
      ]
    }
  ],
  "uiComponents": [
    {
      "title": "LoggedIn State",
      "images": ["https://s3-eu-west-1.amazonaws.com/specdeck-mbb/UCO-Phone-EmptyCart-V1.png"],
      "spec": "Visibility<-**1**",
      "events": [],
      "children": [
        {
          "title": "Pull-To-Refresh",
          "spec": "Visibility = **1.2**  \\nWhen pulled, fire *106*",
          "events": [
            106
          ]
        },
        {
          "title": "Progress Spinner",
          "spec": "Visibility<-**1.1**",
          "events": []
        },
        {
          "title": "Product List",
          "spec": "Disabled if **1.1** or **1.2**  \\nAlpha==2/3 if **1.1** or **1.2**, otherwise 1  \\nGrid: yes, Columns: 2/3/4/5 (depending on screen width)",
          "events": [100]
        }
      ]
    },
    {
      "title": "Error",
      "spec": "**1.4** -> show / hide  \\nwith retry - button -> on click -> fire *105*",
      "events": [
        105
      ]
    }
  ],
  "events": [ ],
  "state": {
    "title": "Watchlist State",
    "flows": [
      {
        "id": 1,
        "title": "Determine LoggedIn State",
        "spec":"UserStore.stream -> exists",
        "flows": [],
        "eventsOutput": [
          {
            "id": 1,
            "name": "Logged in state",
            "attributes": [
              {
                "name": "is logged in?",
                "type": "Boolean"
              }
            ]
          }
        ]
      },
      {
        "id": 2,
        "title": "Fetch Last Seen Products",
        "spec": "SelectedGenderStore.stream()  \\n LastSeenStore.scrollerStream with gender.categoryId",
        "flows": [],
        "eventsOutput": [
          {
            "id": 1,
            "name": "Last Seen Model"
          }
        ]
      }
    ],
    "stateChangers": [
      {
        "eventSource": {
          "type": "flow",
          "id": "1.1"
        },
        "changeTargets": 
        [
          {
            "type": "attribute",
            "id": "1"
          },
          {
            "type": "attribute",
            "id": "2"
          }
        ],
        "changes": "Set user logged in/out state and clear the other"
      },
      {
        "eventSource": {
          "type": "flow",
          "id": "2.1"
        },
        "changeTargets": 
        [
          {
            "type": "attribute",
            "id": "3"
          }
        ],
        "changes": "Set"
      }
    ],
    "eventsOutput": [
      {
        "id": 1,
        "attributes": [
          {
            "id": 1,
            "state": {
              "title": "(User Logged In)",
              "flows": [
                  {
                    "id": 1,
                    "title": "Load Watchlist",
                    "spec":"Watchlist Store.stream",
                    "eventsOutput": [
                      {
                        "id": 1,
                        "name": "Loading"
                      },
                      {
                        "id": 2,
                        "name": "Loaded",
                        "attributes": [
                          {
                            "id": 1,
                            "name": "Watchlist",
                            "type": "List of Products"
                          }
                        ]
                      },
                      {
                        "id": 3,
                        "name": "Error",
                        "attributes": [
                          {
                            "id": 1,
                            "name": "Error",
                            "type": "API-Error"
                          }
                        ]
                      }
                    ]
                  }
              ],
              "stateChangers": [
                {
                  "eventSource": {
                    "type": "flow",
                    "id": "1.1"
                  },
                  "changeTargets": 
                  [
                    {
                      "type": "attribute",
                      "id": "1"
                    }
                  ],
                  "changes": "Set"
                }
              ],
              "eventsOutput": [
                {
                  "id": 1,
                  "attributes": [
                    {
                      "id": 1,
                      "name": "Loading",
                      "type": "Boolean"
                    },
                    {
                      "id": 2,
                      "name": "Loading from pull-to-refresh",
                      "type": "Boolean"
                    },
                    {
                      "id": 3,
                      "state": {
                        "id": 1,
                        "title": "(LoadedList)",
                        "eventsOutput": [
                          {
                            "id": 1,
                            "attributes": [
                              {
                                "id": 1,
                                "name": "Products",
                                "type": "List<Product>"
                              },
                              {
                                "id": 2,
                                "name": "Product Count",
                                "type": "Number"
                              },
                              {
                                "id": 3,
                                "name": "Disabled Product Count",
                                "type": "Number"
                              },
                              {
                                "id": 4,
                                "name": "Loading Next Page",
                                "type": "Boolean"
                              },
                              {
                                "id": 5,
                                "name": "Loading Product Removal",
                                "type": "Boolean"
                              }
                            ],
                            "actions": [
                              {
                                "id": 1,
                                "name": "Scroll list to top"
                              },
                              {
                                "id": 2,
                                "name": "Open Product Screen",
                                "type": "Product"
                              }
                            ]
                          }
                        ]
                      }
                    },
                    {
                      "id": 4,
                      "name": "Error",
                      "type": "Error"
                    }
                  ]
                }
              ]
            }
          },
          {
            "id": 2,
            "state": {
              "id": 2,
              "title": "(User Logged Out)",
              "flows": [
                  {
                    "id": 1,
                    "title": "Check for legacy items",
                    "spec":"Check if legacy exists",
                    "eventsOutput": [
                      {
                        "id": 1,
                        "name": "Has Items?"
                      }
                    ]
                  }
              ],
              "stateChangers": [
                {
                  "eventSource": {
                    "type": "flow",
                    "id": "1.1"
                  },
                  "changeTargets": 
                  [
                    {
                      "type": "attribute",
                      "id": "1"
                    }
                  ],
                  "changes": "Set"
                }
              ],
              "eventsOutput": [
                {
                  "id": 1,
                  "attributes": [
                    {
                      "id": 1,
                      "name": "Has Legacy Watchlist",
                      "type": "Boolean"
                    }
                  ],
                  "actions": [
                    {
                      "id": 1,
                      "name": "Go to Login"
                    },
                    {
                      "id": 2,
                      "name": "Go to Inspiration Tab"
                    }
                  ]
                }
              ]
            }
          },
          {
            "id": 3,
            "state": {
              "id": 3,
              "title": "Last Seen Products",
              "eventsOutput": [
                {
                  "id": 1,
                  "attributes": [
                    {
                      "id": 1,
                      "name": "Loading",
                      "type": "Boolean"
                    },
                    {
                      "id": 2,
                      "state": {
                        "id": 1,
                        "title": "Loaded Last Seen Products",
                        "eventsOutput": [
                          {
                            "id": 1,
                            "attributes": [
                              {
                                "id": 1,
                                "name": "Products",
                                "type": "(List of Products)"
                              },
                              {
                                "id": 2,
                                "name": "Tracking Info",
                                "type": "String"
                              }
                            ]
                          }
                        ]
                      }
                    },
                    {
                      "id": 3,
                      "name": "Error",
                      "type": "(Error)"
                    }
                  ],
                  "actions": [
                    {
                      "id": 1,
                      "name": "Open Product Screen",
                      "type": "Product"
                    }
                  ]
                }
              ]
            }
          },
          {
            "id": 4,
            "name": "Dummy",
            "type": "Boolean"
          }
        ]
      }
    ]
  }
}`;



// WEBPACK FOOTER //
// ./src/components/watchlist.js